module.exports = ".wrapper-full-page { height: 100vh; }\n\n.main-centered { min-height: 100%; padding-top: 0; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; }\n\nh1, h3 { margin: 50px; padding: 0; }\n\n.fa { font-size: 70px; color: #ffbe00; }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/pages/forbidden.component.css
// module id = ./src/app/modules/shared/pages/forbidden.component.css
// module chunks = main